import React, { forwardRef } from "react";
import ListItemButton from "@mui/material/ListItemButton";

const MenuItemComponent = (props) => {
  const { className, onClick, toggleMenu, link, children, linkLevel } = props;

  // If linkLevel is not set, it suggests it's a primary link
  if (!linkLevel) {
    return (
      <ListItemButton
        className={className}
        // component={LinkComponent} // Use RouterLink for navigation
        onClick={onClick}
      >
        {children}
      </ListItemButton>
    );
  }

  // For secondary links or when special handling is needed that does not navigate

  return (
    <ListItemButton
      className={className}
      onClick={onClick} // Still handle onClick but no navigation here
    >
      {children}
    </ListItemButton>
  );
};

export default MenuItemComponent;
